import {Notification} from 'element-ui';
// Initial state
const state = {
	user : null,
	isAuth : false
};

// Getters
const getters = {
	userFullName: state => state.user && state.user.people ? state.user.people.full_name:'',
	userFullNameLegalAdvisor: state => state.user && state.user.advisor_legal ? state.user.advisor_legal.full_name:'',
	userEmail: state => state.user ? state.user.email:'',
	isAuth: state => state.user,
	cat_profile_id: state => state.user ? state.user.cat_profile_id : null,
	user_hash: state => state.user ? state.user.hash : null,
	userInfo: state => state.user,
	peopleId:state => state.user && state.user.people ? state.user.people.id:null,
	peopleHashId:state => state.user && state.user.people ? state.user.people.hash_id:null,
	peopleAdvisorTrainingCount : state => state.user && state.user.people  && state.user.people.people_advisor_training_count ? state.user.people.people_advisor_training_count: 0,
	userPeople: state => state.user && state.user.people ? state.user.people:null,
	peopleStatusiId:state => state.user && state.user.people ? state.user.people.cat_people_status_id:null,
};

// Actions
const actions = {

	setAuth({state, commit}, payload) {
		return new Promise((resolve, reject) => {
			window.sessionStorage.setItem('sre_young_token', payload.sre_young_token);
			//splash
			window.sessionStorage.removeItem('srsv_splash');

			window.axios.defaults.headers.common = {
				'Accept': 'application/json',
				'X-Requested-With': 'XMLHttpRequest',
				'Authorization': 'Bearer ' + sessionStorage.getItem('sre_young_token'),
				'Accept-C': window.acceptC
			};
			commit('setUser', payload.user);
			resolve(true);

		}, error => {
			reject(error);
		})
	},

	setLogOut({state, commit, dispatch}) {

		Notification.closeAll();
		dispatch('loading/spinner', {msg: 'Cerrando sesión...', status: true}, {root: true});

		return axios.post('/api/logout')
			.then(response => {
				dispatch('loading/spinner', {}, {root: true});

				if (response.data.authenticated === false) {

					window.sessionStorage.removeItem('sr_young_token');
					window.axios.defaults.headers.common = {
						'Authorization': 'Bearer'
					};
					commit('deleteUser');

					return Promise.resolve(true);

				} else {
					dispatch('loading/spinner', {}, {root: true});
					dispatch('notifications/warning', {msg: 'Existió un error al intentar cerarr la sesión.'}, {root: true});
					return Promise.reject(false);
				}
			}).catch((err) => {
				console.log(err);
				return Promise.reject(err);
			});
	}

};

// Mutations
const mutations = {
	setUser(state, user) {
		state.user = user;
		state.isAuth = true;
	},
	deleteUser(state) {
		state.user = null;
		state.isAuth = false;
	},
};

export default {
	state,
	getters,
	actions,
	mutations
}
